/** Pure geometry helpers for radially-positioned Nexus nodes (Career DNA data nodes +
 * Skill Galaxy nodes) — no JSX here, just math, kept separate so NexusCore.js stays focused
 * on rendering. */
export function polarToPercent(angleDeg, radiusPct, cx = 50, cy = 50) {
  const rad = ((angleDeg - 90) * Math.PI) / 180;
  return {
    left: `${cx + radiusPct * Math.cos(rad)}%`,
    top: `${cy + radiusPct * Math.sin(rad)}%`,
  };
}

export function polarToSvgPoint(angleDeg, radius, cx = 200, cy = 200) {
  const rad = ((angleDeg - 90) * Math.PI) / 180;
  return { x: cx + radius * Math.cos(rad), y: cy + radius * Math.sin(rad) };
}
